import Vue from 'vue';

// import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
// AOS.init();
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Tailwind
// import "./assets/css/main.css";

import "./assets/css/animate.css";
import "./assets/css/tailwind.css";

window.WOW = require('wowjs').WOW;

// Vee-Validate
import "./vee-validate";

// VueSimpleAlert
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

// main.js
import Photoswipe from 'vue-pswipe';

Vue.use(Photoswipe, {});

// Vue
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');
